import {mainQuery} from '@github-ui/react-core/future/main-query'

import {mcpRegistryAppBuilder} from '../config/app-builder'

import type {McpRegistryResponse} from '../types'

export const mcpRegistryRoute = mcpRegistryAppBuilder.createQueryRouteConfig('mcpRegistryRoute', {
  path: '/mcp',
  queries: [
    mainQuery<McpRegistryResponse>({
      queryDeps: ({pathname, searchParams}) => {
        const cursor = searchParams.get('cursor') || ''
        const limit = searchParams.get('limit') || '100'
        const query = searchParams.get('q') || ''

        const params = new URLSearchParams()
        if (cursor) params.set('cursor', cursor)
        params.set('limit', limit)
        if (query) params.set('q', query)

        const pathWithParams = params.toString() ? `${pathname}?${params.toString()}` : pathname

        return {pathname: pathWithParams}
      },
    }),
  ],
})
